(function () {
  var MESSAGE_SOURCE = "piece-of-sign-design-maker";
  var MESSAGE_VERSION = 1;
  var READY_WAIT_MS = 12000;
  var UPLOAD_CANCELLED_CODE = "UPLOAD_CANCELLED";
  // 注文明細に残す利用目印。先頭が "_" のためカート・チェックアウトでは顧客に表示されない。
  var USAGE_PROPERTY_NAME = "properties[_design_maker]";

  function safeText(value) {
    return String(value || "").trim();
  }

  function normalizeFaceKey(value) {
    var key = safeText(value).toLowerCase();
    if (key === "front" || key === "back") return key;
    return "";
  }

  function faceKeyFromText(value) {
    var text = safeText(value);
    if (!text) return "";
    if (/^(?:★\s*)?ex(?:[.．:\s]|$)/i.test(text) || /裏面|\bback\b/i.test(text)) return "back";
    if (/表面|\bfront\b/i.test(text)) return "front";
    return "";
  }

  function compareNodes(left, right) {
    if (!left || !right || left === right) return 0;
    var position = left.compareDocumentPosition(right);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
    return 0;
  }

  function isVisibleNode(node) {
    if (!node || !node.isConnected) return false;
    var option = node.closest ? node.closest(".cl-po--option") : null;
    var target = option || node;
    return !target.hidden && target.getClientRects().length > 0;
  }

  function fieldContext(target, field) {
    var parts = [];
    if (target && target.closest) {
      var container = target.closest(".cl-po--option, [data-upload-lift], .upload-lift, .filepond--root, label");
      if (container) parts.push(container.textContent || "");
    }
    if (field) {
      parts.push(field.name || "", field.id || "");
      if (field.config) parts.push(field.config.name || "", field.config.label || "", field.config.title || "");
    }
    return parts.join(" ").replace(/\s+/g, " ").trim();
  }

  function initialize(root) {
    if (root.dataset.initialized === "1") return;
    root.dataset.initialized = "1";

    var params = new URLSearchParams(window.location.search);
    var enabled = params.get("designMakerTest") === "1" || root.dataset.alwaysEnabled === "1";
    if (!enabled) return;

    var makerUrl = new URL(root.dataset.makerUrl, window.location.href);
    var makerOrigin = makerUrl.origin;
    var productHandle = root.dataset.productHandle || "the-sign-a-frame";
    var preferredFieldName = root.dataset.uploadFieldName || "入稿データ";
    var uploadRouteLabel = root.dataset.uploadRouteLabel || "専用テンプレートでつくる";
    var maxUploadBytes = Number(root.dataset.maxUploadBytes || 52428800);
    var ga4MeasurementId = root.dataset.ga4MeasurementId || "G-FWDGGHEVVL";
    var externalTriggerSelector = root.dataset.externalTriggerSelector || "[data-design-maker-external-trigger], .pos-design-route__button[href*='magic-signage-desin']";
    var triggerScope = root.closest("form") || document;
    var trigger = root.querySelector("[data-design-maker-open]");
    var modal = root.querySelector("[data-design-maker-modal]");
    var iframeTemplate = root.querySelector("[data-design-maker-frame]");
    var iframe = iframeTemplate;
    var faceFrames = {};
    var closeButtons = root.querySelectorAll("[data-design-maker-close]");
    var modalStatus = root.querySelector("[data-design-maker-modal-status]");
    var resultTemplate = root.querySelector("[data-design-maker-result-template], [data-design-maker-result]");
    var uploadFields = [];
    var uploadWaiters = [];
    var uploadRegistrationIndex = 0;
    var faceStates = {
      front: { trigger: null, result: null, objectUrl: "" },
      back: { trigger: null, result: null, objectUrl: "" }
    };
    // 面ごとに、Design Makerから入稿欄へ渡したファイルのURL
    var appliedUploads = { front: "", back: "" };
    var previousFocus = null;
    var busy = false;
    var activeTrigger = null;
    var activeFaceKey = "";
    var triggerObserver = null;

    if (resultTemplate && !resultTemplate.hasAttribute("data-design-maker-result-template")) {
      resultTemplate.setAttribute("data-design-maker-result-template", "");
      resultTemplate.removeAttribute("data-design-maker-result");
      resultTemplate.hidden = true;
    }

    root.hidden = false;

    function setModalStatus(message, status) {
      if (!modalStatus) return;
      modalStatus.textContent = message || "";
      modalStatus.dataset.status = status || "";
    }

    function setBusy(value) {
      busy = value;
      root.dataset.busy = value ? "1" : "0";
      closeButtons.forEach(function (button) {
        button.disabled = value;
      });
    }

    // 利用イベントを GA4 へ直接送る。
    // JPストアの GA4 は Shopify の Google アプリが gtag で読み込んでおり、GTM コンテナ
    // （アプリ GroPulse が別名データレイヤーで読み込み）には GA4 の Google タグが無い。
    // GTM 経由では届かないため、ページ上の gtag に send_to を付けて GA4 だけに送る
    // （同じ gtag に設定されている Google 広告へは送らない）。
    // gtag の定義が遅れている間のイベントは、件数と期限を区切って保留し、定義後に一度だけ送る。
    var pendingEvents = [];
    var pendingTimer = 0;
    var PENDING_LIMIT = 20;
    var PENDING_WAIT_MS = 30000;
    var PENDING_POLL_MS = 500;

    function sendEvent(entry) {
      try {
        window.gtag("event", entry.name, entry.params);
      } catch (error) {
        // 計測の失敗で入稿フローを止めない
      }
    }

    function flushPendingEvents() {
      if (typeof window.gtag !== "function") return false;
      pendingEvents.splice(0).forEach(sendEvent);
      return true;
    }

    function waitForGtag() {
      if (pendingTimer) return;
      var startedAt = Date.now();
      pendingTimer = window.setInterval(function () {
        if (flushPendingEvents() || Date.now() - startedAt > PENDING_WAIT_MS) {
          window.clearInterval(pendingTimer);
          pendingTimer = 0;
          pendingEvents.length = 0;
        }
      }, PENDING_POLL_MS);
    }

    function track(eventName, faceKey, reason) {
      var params = {
        send_to: ga4MeasurementId,
        dm_product: productHandle,
        dm_face: faceKey || ""
      };
      if (reason) params.dm_reason = reason;
      var entry = { name: eventName, params: params };
      if (flushPendingEvents()) {
        sendEvent(entry);
        return;
      }
      if (pendingEvents.length < PENDING_LIMIT) pendingEvents.push(entry);
      waitForGtag();
    }

    // Design Makerで作ったファイルが、まだ入稿欄に残っている面だけを返す。
    // Cloudliftはアップロード済みファイルごとに value=ファイルURL の隠し入力をフォームに置き、
    // ファイルを削除・差し替えると入力も消すため、その有無で判定する。
    function facesWithLiveDesign(form) {
      var elements = Array.from(form.elements);
      return Object.keys(appliedUploads).filter(function (faceKey) {
        var applied = appliedUploads[faceKey];
        if (!applied) return false;
        return elements.some(function (element) {
          return element.name && element.name !== USAGE_PROPERTY_NAME && !element.disabled && element.value === applied;
        });
      });
    }

    function syncUsageProperty() {
      var form = root.closest("form");
      if (!form) return [];
      var faces = facesWithLiveDesign(form);
      var input = Array.from(form.elements).find(function (element) {
        return element.name === USAGE_PROPERTY_NAME;
      });
      if (!faces.length) {
        if (input) input.remove();
        return faces;
      }
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = USAGE_PROPERTY_NAME;
        root.appendChild(input);
      }
      input.value = faces.join(",");
      return faces;
    }

    function scheduleUsageSync() {
      window.setTimeout(syncUsageProperty, 0);
    }

    // テーマはカート追加中にボタンへ btn--loading を付け、その間の再送信を通信せず捨てる。
    // 捨てられる送信まで数えないよう、通信中は計測だけ止める（目印の同期は続ける）。
    function handleFormSubmit(event) {
      var form = root.closest("form");
      if (event.target !== form) return;
      var cartRequestInFlight = Boolean(form.querySelector(".add-to-cart.btn--loading"));
      var faces = syncUsageProperty();
      if (faces.length && !cartRequestInFlight) track("design_maker_cart_submit", faces.join(","));
    }

    // その入稿欄が置いた隠し入力の値一覧（UploadLiftがURLを返さなかった場合の照合用）。
    // UploadLiftは入力名を properties[<field>] / properties[<field>_<連番>] にするため、
    // 入稿欄の field 名で絞り、フォーム内の無関係な隠し入力をファイルと取り違えない。
    function uploadInputValues(uploadField) {
      var form = root.closest("form");
      var fieldName = uploadField && uploadField.config && safeText(uploadField.config.field);
      if (!form || !fieldName) return [];
      var exact = "[" + fieldName + "]";
      var numbered = "[" + fieldName + "_";
      return Array.from(form.elements).filter(function (element) {
        if (!element.name || element.type !== "hidden" || !element.value || element.disabled) return false;
        return element.name.slice(-exact.length) === exact || element.name.indexOf(numbered) !== -1;
      }).map(function (element) { return element.value; });
    }

    // アップロード後に増えた入稿欄の値を、DOM反映の遅れを見込んで期限付きで探す。
    // 1件に定まらなければ空文字（＝目印を付けない）。
    function findAddedUploadValue(uploadField, valuesBefore) {
      var deadline = Date.now() + 3000;
      return new Promise(function (resolve) {
        (function check() {
          var added = uploadInputValues(uploadField).filter(function (value) {
            return valuesBefore.indexOf(value) === -1;
          });
          if (added.length === 1) return resolve(added[0]);
          if (added.length > 1 || Date.now() > deadline) return resolve("");
          window.setTimeout(check, 100);
        }());
      });
    }

    function designMakerUrl(faceKey) {
      var url = new URL(makerUrl.href);
      url.searchParams.set("product", productHandle);
      url.searchParams.set("embed", "1");
      url.searchParams.set("parentOrigin", window.location.origin);
      url.searchParams.set("returnUrl", window.location.href);
      if (faceKey) url.searchParams.set("face", faceKey);
      return url.href;
    }

    // 表裏で同じiframeを再読込すると、先に作った面の編集状態が失われる。
    // 面ごとのiframeを遅延生成して保持し、再編集時は既存の画面へ戻す。
    function frameForFace(faceKey) {
      if (faceFrames[faceKey]) return faceFrames[faceKey];
      var frame = Object.keys(faceFrames).length === 0
        ? iframeTemplate
        : iframeTemplate.cloneNode(false);
      if (frame !== iframeTemplate) {
        frame.removeAttribute("src");
        frame.hidden = true;
        modal.insertBefore(frame, modalStatus || null);
      }
      frame.dataset.designMakerFrameFace = faceKey;
      faceFrames[faceKey] = frame;
      return frame;
    }

    function activateFrame(faceKey) {
      var frame = frameForFace(faceKey);
      Object.keys(faceFrames).forEach(function (key) {
        faceFrames[key].hidden = key !== faceKey;
      });
      frame.hidden = false;
      iframe = frame;
      return frame;
    }

    function ensureUploadRouteSelected(faceKey) {
      if (chooseUploadField(faceKey)) return;
      var form = root.closest("form");
      if (!form) return;
      var wrapper = form.querySelector(".cl-po--wrapper");
      if (!wrapper) return;
      var expected = safeText(uploadRouteLabel).toLowerCase();
      var candidates = Array.from(wrapper.querySelectorAll("label, button, .cl-po--swatch"));
      var target = candidates.find(function (element) {
        return safeText(element.textContent).toLowerCase().indexOf(expected) !== -1;
      });
      if (target) target.click();
    }

    function openModal(options) {
      var requestedFaceKey = options && normalizeFaceKey(options.faceKey);
      var nextFaceKey = requestedFaceKey || activeFaceKey || "front";
      previousFocus = document.activeElement;
      // 外部ボタンはCloudliftの対象区画内にあるため、選択状態を変更しない。
      // ブリッジ単体の入口から開いた場合だけ、必要な入稿経路を選ぶ。
      if (!activeTrigger) ensureUploadRouteSelected(nextFaceKey);
      // 表裏で編集画面そのものを分け、別の面へ移動しても入力状態を保持する。
      iframe = activateFrame(nextFaceKey);
      var nextUrl = designMakerUrl(nextFaceKey);
      if (!iframe.src || iframe.src !== nextUrl) {
        iframe.src = nextUrl;
        // アプリの読み込み開始。ready は読み込みごとに1回なので、比べるのは open ではなく load
        track("design_maker_load", nextFaceKey);
      }
      activeFaceKey = nextFaceKey;
      modal.hidden = false;
      document.body.classList.add("pos-design-maker-modal-open");
      setModalStatus("", "");
      track("design_maker_open", nextFaceKey);
      var closeButton = modal.querySelector("[data-design-maker-close]");
      if (closeButton) closeButton.focus();
    }

    function placeResultBelowRoutes(externalTrigger, resultPanel) {
      if (!externalTrigger || !externalTrigger.parentNode || !resultPanel) return;
      var routeButtons = externalTrigger.closest(".pos-design-route__buttons");
      var route = routeButtons ? routeButtons.parentNode : externalTrigger.closest(".pos-design-route");
      if (!route) return;
      var slot = Array.from(route.children).find(function (child) {
        return child.hasAttribute("data-design-maker-result-slot");
      });
      if (!slot) {
        slot = document.createElement("div");
        slot.dataset.designMakerResultSlot = "1";
        if (routeButtons) routeButtons.insertAdjacentElement("afterend", slot);
        else route.appendChild(slot);
      }
      if (resultPanel.parentNode !== slot) slot.appendChild(resultPanel);
    }

    function findExternalTrigger(faceKey) {
      stampExternalTriggerFaces();
      return externalTriggers().find(function (externalTrigger) {
        var triggerProduct = externalTrigger.dataset.designMakerProduct || "";
        if (triggerProduct && triggerProduct !== productHandle) return false;
        return !faceKey || faceOfTrigger(externalTrigger).key === faceKey;
      });
    }

    function handleExternalTrigger(event) {
      if (!event.target || !event.target.closest) return;
      var externalTrigger = event.target.closest(externalTriggerSelector);
      if (!externalTrigger) return;
      // 修飾キー付き・左クリック以外はブラウザ既定の動作（新規タブで開く等）に任せる
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      var triggerProduct = externalTrigger.dataset.designMakerProduct || "";
      if (triggerProduct && triggerProduct !== productHandle) return;
      event.preventDefault();
      stampExternalTriggerFaces();
      var face = faceOfTrigger(externalTrigger);
      externalTrigger.dataset.designMakerFace = face.key;
      activeTrigger = externalTrigger;
      activeFaceKey = face.key;
      faceStates[face.key].trigger = externalTrigger;
      if (faceStates[face.key].result) placeResultBelowRoutes(externalTrigger, faceStates[face.key].result);
      openModal({ faceKey: face.key });
    }

    function closeModal() {
      if (busy) return;
      modal.hidden = true;
      document.body.classList.remove("pos-design-maker-modal-open");
      if (previousFocus && typeof previousFocus.focus === "function") previousFocus.focus();
      previousFocus = null;
    }

    function registerUploadField(event) {
      var field = event.detail;
      if (!field || typeof field.uploadFile !== "function") return;
      if (uploadFields.some(function (entry) { return entry.field === field; })) return;
      var node = event.target && event.target.nodeType === 1 ? event.target : null;
      uploadFields.push({
        field: field,
        node: node,
        faceKey: faceOfUploadField(node, field),
        context: fieldContext(node, field),
        registrationIndex: uploadRegistrationIndex++
      });
      uploadWaiters.splice(0).forEach(function (resolve) { resolve(); });
    }

    function faceOfUploadField(node, field) {
      var explicit = node && node.closest ? node.closest("[data-design-maker-face]") : null;
      var explicitKey = explicit ? normalizeFaceKey(explicit.dataset.designMakerFace) : "";
      if (explicitKey) return explicitKey;

      var option = node && node.closest ? node.closest(".cl-po--option") : null;
      var optionKey = option ? faceKeyFromText(option.dataset.option || "") : "";
      if (optionKey) return optionKey;

      var config = field && field.config ? field.config : {};
      var values = [field && field.name, field && field.id, config.field, config.name, config.label, config.title];
      var detected = values.map(faceKeyFromText).find(function (key) { return key; });
      return detected || "front";
    }

    function externalTriggers() {
      return Array.from(triggerScope.querySelectorAll(externalTriggerSelector)).filter(function (externalTrigger) {
        var triggerProduct = externalTrigger.dataset.designMakerProduct || "";
        return !triggerProduct || triggerProduct === productHandle;
      });
    }

    function triggerFaceFromContext(externalTrigger) {
      if (!externalTrigger) return "";

      // Cloudliftが表面のDOMを複製して裏面区画を作る場合、複製元の
      // data-design-maker-face="front" まで引き継がれることがある。
      // そのため、ボタン上のキャッシュより区画本来の Ex. 識別子を優先する。
      var option = externalTrigger.closest ? externalTrigger.closest(".cl-po--option") : null;
      if (option) {
        var optionValues = [
          option.dataset.option,
          option.dataset.name,
          option.getAttribute("aria-label")
        ];
        var optionKey = optionValues.map(faceKeyFromText).find(function (key) { return key; });
        if (optionKey) return optionKey;
      }

      var explicit = externalTrigger.closest ? externalTrigger.closest("[data-design-maker-face]") : null;
      var explicitKey = explicit ? normalizeFaceKey(explicit.dataset.designMakerFace) : "";
      if (explicitKey) return explicitKey;

      try {
        var linkedFaceKey = normalizeFaceKey(new URL(externalTrigger.href, window.location.href).searchParams.get("face"));
        if (linkedFaceKey) return linkedFaceKey;
      } catch (error) {
        // hrefがURLとして解釈できない場合は、ほかの識別情報へフォールバックする。
      }
      return "";
    }

    // Cloudliftは選択変更やアップロード後にオプション内のDOMを再描画する。
    // 描画された時点で表裏をボタン自体へ記録し、その後DOMの並びが変わっても面を取り違えない。
    function stampExternalTriggerFaces() {
      var triggers = externalTriggers();
      triggers.forEach(function (externalTrigger) {
        var contextualKey = triggerFaceFromContext(externalTrigger);
        if (contextualKey && normalizeFaceKey(externalTrigger.dataset.designMakerFace) !== contextualKey) {
          externalTrigger.dataset.designMakerFace = contextualKey;
        }
      });

      if (triggers.length < 2) return;
      triggers.sort(compareNodes);
      triggers.forEach(function (externalTrigger, index) {
        if (normalizeFaceKey(externalTrigger.dataset.designMakerFace)) return;
        externalTrigger.dataset.designMakerFace = index === 0 ? "front" : "back";
      });
    }

    function uploadFaceAfterTrigger(externalTrigger) {
      if (!externalTrigger) return "";
      var following = uploadFields.filter(function (entry) {
        if (!entry.node || !entry.node.isConnected) return false;
        return !!(externalTrigger.compareDocumentPosition(entry.node) & Node.DOCUMENT_POSITION_FOLLOWING);
      }).sort(function (left, right) {
        return compareNodes(left.node, right.node) || left.registrationIndex - right.registrationIndex;
      });
      return following.length ? normalizeFaceKey(following[0].faceKey) : "";
    }

    // Cloudliftの裏面区画は data-option / フィールド名が "Ex." で始まる。
    // 表示順は最後のフォールバックにとどめ、通常はこの明示的な識別子で面を決める。
    function faceOfTrigger(externalTrigger) {
      var contextualKey = triggerFaceFromContext(externalTrigger);
      if (contextualKey) return { key: contextualKey };

      var uploadFaceKey = uploadFaceAfterTrigger(externalTrigger);
      if (uploadFaceKey) return { key: uploadFaceKey };

      var route = externalTrigger && externalTrigger.closest ? externalTrigger.closest(".pos-design-route") : null;
      var routes = Array.from(triggerScope.querySelectorAll(".pos-design-route"));
      var index = route ? routes.indexOf(route) : -1;
      var fallbackKey = index > 0 ? "back" : "front";
      return { key: fallbackKey };
    }

    function liveUploadEntries(faceKey) {
      uploadFields = uploadFields.filter(function (entry) {
        return !entry.node || entry.node.isConnected;
      });
      var entries = uploadFields.filter(function (entry) {
        return !faceKey || entry.faceKey === faceKey;
      });
      var visible = entries.filter(function (entry) { return isVisibleNode(entry.node); });
      return visible.length ? visible : entries;
    }

    // 登録イベントの発火順ではなく、DOM上でボタンに最も近い同じ面の欄を返す。
    function uploadFieldAfter(node, faceKey) {
      if (!node || !uploadFields.length) return null;
      var following = liveUploadEntries(faceKey).filter(function (entry) {
        if (!entry.node || !entry.node.isConnected) return false;
        return !!(node.compareDocumentPosition(entry.node) & Node.DOCUMENT_POSITION_FOLLOWING);
      }).sort(function (left, right) {
        return compareNodes(left.node, right.node) || left.registrationIndex - right.registrationIndex;
      });
      return following.length ? following[0].field : null;
    }

    function chooseUploadField(faceKey) {
      var candidates = liveUploadEntries(faceKey);
      if (!candidates.length) return null;
      var preferred = safeText(preferredFieldName).toLowerCase();
      var ranked = candidates.map(function (entry) {
        var context = safeText(entry.context).toLowerCase();
        var score = context.indexOf(preferred) !== -1 ? 10 : 0;
        if (/入稿|完成データ|design|artwork/.test(context)) score += 3;
        return { entry: entry, score: score };
      }).sort(function (left, right) {
        return right.score - left.score
          || compareNodes(left.entry.node, right.entry.node)
          || left.entry.registrationIndex - right.entry.registrationIndex;
      });
      return ranked[0].entry.field;
    }

    function resolveUploadField(faceKey, triggerNode) {
      var scoped = triggerNode ? uploadFieldAfter(triggerNode, faceKey) : null;
      return scoped || chooseUploadField(faceKey);
    }

    function waitForUploadField(faceKey, triggerNode) {
      var immediate = resolveUploadField(faceKey, triggerNode);
      if (immediate) return Promise.resolve(immediate);
      return new Promise(function (resolve, reject) {
        var timeout = window.setTimeout(function () {
          var index = uploadWaiters.indexOf(onReady);
          if (index !== -1) uploadWaiters.splice(index, 1);
          var field = resolveUploadField(faceKey, triggerNode);
          if (field) resolve(field);
          else reject(new Error("商品ページの入稿フィールドを取得できませんでした。"));
        }, READY_WAIT_MS);

        function onReady() {
          var field = resolveUploadField(faceKey, triggerNode);
          if (!field) return;
          window.clearTimeout(timeout);
          resolve(field);
        }

        uploadWaiters.push(onReady);
      });
    }

    function postResult(targetWindow, targetOrigin, requestId, ok, message, code) {
      targetWindow.postMessage({
        source: MESSAGE_SOURCE,
        version: MESSAGE_VERSION,
        type: "pos-design-maker:result",
        requestId: requestId,
        ok: ok,
        message: message || "",
        code: code || ""
      }, targetOrigin);
    }

    function ensureResultPanel(faceKey, externalTrigger) {
      if (!resultTemplate) return null;
      var state = faceStates[faceKey];
      if (!state.result) {
        var panel = resultTemplate.cloneNode(true);
        panel.removeAttribute("data-design-maker-result-template");
        panel.setAttribute("data-design-maker-result", "");
        panel.dataset.designMakerResultFace = faceKey;
        panel.hidden = true;
        var editButton = panel.querySelector("[data-design-maker-edit]");
        if (editButton) {
          editButton.addEventListener("click", function () {
            var faceTrigger = state.trigger && state.trigger.isConnected
              ? state.trigger
              : findExternalTrigger(faceKey);
            if (faceTrigger) {
              activeTrigger = faceTrigger;
              state.trigger = faceTrigger;
            }
            activeFaceKey = faceKey;
            openModal({ faceKey: faceKey });
          });
        }
        state.result = panel;
      }
      if (externalTrigger) placeResultBelowRoutes(externalTrigger, state.result);
      else if (!state.result.isConnected) root.insertBefore(state.result, modal);
      return state.result;
    }

    function showResult(blob, fileName, faceKey, triggerNode) {
      var state = faceStates[faceKey];
      var externalTrigger = triggerNode && triggerNode.isConnected
        ? triggerNode
        : findExternalTrigger(faceKey);
      if (externalTrigger) state.trigger = externalTrigger;
      var resultPanel = ensureResultPanel(faceKey, externalTrigger);
      if (!resultPanel) return;
      var resultImage = resultPanel.querySelector("[data-design-maker-result-image]");
      var resultName = resultPanel.querySelector("[data-design-maker-result-name]");
      if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
      state.objectUrl = URL.createObjectURL(blob);
      resultImage.src = state.objectUrl;
      resultImage.alt = "反映したデザインのプレビュー";
      resultName.textContent = fileName;
      resultPanel.hidden = false;
      root.dataset.completed = "1";
      root.dataset[faceKey === "back" ? "completedBack" : "completedFront"] = "1";
    }

    // UploadLiftのDokaエディターは「取り消し」時に uploadFile() のPromiseを
    // resolve / reject しないため、キャンセル操作を別途検知して待機を終了する。
    function uploadFileWithCancellation(uploadField, blob) {
      return new Promise(function (resolve, reject) {
        var settled = false;

        function cleanup() {
          document.removeEventListener("click", onCancelClick, true);
          document.removeEventListener("keydown", onCancelKey, true);
        }

        function finish(callback, value) {
          if (settled) return;
          settled = true;
          cleanup();
          callback(value);
        }

        function cancelUpload() {
          var error = new Error("UploadLiftのアップロードがキャンセルされました。");
          error.code = UPLOAD_CANCELLED_CODE;
          finish(reject, error);
        }

        function onCancelClick(event) {
          var target = event.target && event.target.closest
            ? event.target.closest(".doka--button-action-cancel")
            : null;
          if (target) cancelUpload();
        }

        function onCancelKey(event) {
          if (event.key === "Escape" && document.querySelector(".doka--root")) cancelUpload();
        }

        document.addEventListener("click", onCancelClick, true);
        document.addEventListener("keydown", onCancelKey, true);
        // アプリで作った画像は切り抜き不要なので、UploadLiftの切り抜き画面(Doka)を出さずに入稿する。
        // UploadLift(app-upload.js 0.14.60で確認)は _picked 付きのファイルを編集対象外にする。非公開の内部仕様なので、
        // UploadLiftの更新後は「反映→カート追加」を必ず試す。
        // 注意: 入稿欄に縦横比の指定(imageEditorCropRatios)を入れると、比率が合わない画像は画面で直せずエラーになる。
        // Design Maker対象商品の入稿欄には縦横比を指定しないこと。
        // Blobに付けた目印はFilePond内で包み直されて消えるため、Fileにしてから付ける。
        Promise.resolve()
          .then(function () {
            var designFile = new File([blob], "design-maker.png", { type: "image/png" });
            designFile._picked = true;
            return uploadField.uploadFile(designFile);
          })
          .then(
            function (file) { finish(resolve, file); },
            function (error) { finish(reject, error); }
          );
      });
    }

    async function uploadDesign(event, data, sourceFaceKey) {
      if (busy) return;
      var submissionFaceKey = normalizeFaceKey(sourceFaceKey) || activeFaceKey || "front";
      if (!(data.blob instanceof Blob) || data.blob.type !== "image/png") {
        track("design_maker_failed", submissionFaceKey, "invalid_png");
        postResult(event.source, event.origin, data.requestId, false, "PNGデータを受け取れませんでした。");
        return;
      }
      if (data.blob.size <= 0 || data.blob.size > maxUploadBytes) {
        track("design_maker_failed", submissionFaceKey, "too_large");
        postResult(event.source, event.origin, data.requestId, false, "画像サイズがアップロード上限を超えています。");
        return;
      }

      setBusy(true);
      setModalStatus("入稿データを商品に反映しています…", "loading");
      var submissionTrigger = faceStates[submissionFaceKey].trigger;
      if (!submissionTrigger || !submissionTrigger.isConnected) {
        submissionTrigger = findExternalTrigger(submissionFaceKey);
      }
      try {
        var uploadField = await waitForUploadField(submissionFaceKey, submissionTrigger);
        var valuesBeforeUpload = uploadInputValues(uploadField);
        var uploadedFile = await uploadFileWithCancellation(uploadField, data.blob);
        var uploadedUrl = uploadedFile && typeof uploadedFile.url === "string" ? uploadedFile.url : "";
        if (!uploadedUrl) {
          // URLが返らない場合は、この入稿欄で新たに増えた隠し入力の値をファイルURLとみなす
          uploadedUrl = await findAddedUploadValue(uploadField, valuesBeforeUpload);
        }
        // 照合できるURLが無いときは、削除後も残る誤った目印を避けるため付与しない
        appliedUploads[submissionFaceKey] = uploadedUrl;
        syncUsageProperty();
        track("design_maker_applied", submissionFaceKey, uploadedUrl ? "" : "unverified");
        showResult(data.blob, data.fileName || "piece-of-sign-design.png", submissionFaceKey, submissionTrigger);
        setModalStatus("デザインを反映しました。", "success");
        postResult(event.source, event.origin, data.requestId, true, "デザインを反映しました。");
        root.dispatchEvent(new CustomEvent("pos-design-maker:uploaded", {
          bubbles: true,
          detail: { face: submissionFaceKey, fileName: data.fileName || "", size: data.blob.size }
        }));
        window.setTimeout(function () {
          setBusy(false);
          closeModal();
        }, 700);
      } catch (error) {
        setBusy(false);
        if (error && error.code === UPLOAD_CANCELLED_CODE) {
          track("design_maker_failed", submissionFaceKey, "cancelled");
          setModalStatus("アップロードをキャンセルしました。", "");
          postResult(
            event.source,
            event.origin,
            data.requestId,
            false,
            "アップロードをキャンセルしました。",
            UPLOAD_CANCELLED_CODE
          );
          return;
        }
        track("design_maker_failed", submissionFaceKey, "error");
        setModalStatus("反映できませんでした。商品ページを再読み込みしてお試しください。", "error");
        postResult(event.source, event.origin, data.requestId, false, error.message || "アップロードに失敗しました。");
      }
    }

    function faceKeyForMessageSource(source) {
      return Object.keys(faceFrames).find(function (faceKey) {
        return faceFrames[faceKey].contentWindow === source;
      }) || "";
    }

    function handleMessage(event) {
      if (event.origin !== makerOrigin) return;
      var sourceFaceKey = faceKeyForMessageSource(event.source);
      if (!sourceFaceKey) return;
      var data = event.data || {};
      if (data.source !== MESSAGE_SOURCE || data.version !== MESSAGE_VERSION) return;
      if (data.productHandle !== productHandle) return;
      if (data.type === "pos-design-maker:ready") {
        // 読み込み（load）に対して ready が少なければ、アプリ側の読み込み失敗を疑う
        track("design_maker_ready", sourceFaceKey);
        if (sourceFaceKey === activeFaceKey) setModalStatus("", "ready");
        return;
      }
      if (data.type === "pos-design-maker:close") {
        if (sourceFaceKey === activeFaceKey) closeModal();
        return;
      }
      if (data.type === "pos-design-maker:submit") uploadDesign(event, data, sourceFaceKey);
    }

    stampExternalTriggerFaces();
    triggerObserver = new MutationObserver(stampExternalTriggerFaces);
    triggerObserver.observe(triggerScope, { childList: true, subtree: true });
    window.addEventListener("upload:ready", registerUploadField);
    window.addEventListener("message", handleMessage);
    // 入稿欄のファイル追加・削除、オプション切替のたびに目印を最新化し、送信直前にも確定させる。
    // 送信を介さない購入ボタン（今すぐ購入等）でも、その時点の状態がフォームに載っているようにするため。
    document.addEventListener("upload:added", scheduleUsageSync);
    document.addEventListener("upload:removed", scheduleUsageSync);
    triggerScope.addEventListener("change", scheduleUsageSync);
    document.addEventListener("submit", handleFormSubmit, true);
    if (trigger) trigger.addEventListener("click", openModal);
    document.addEventListener("click", handleExternalTrigger, true);
    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeModal);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) closeModal();
    });
    window.addEventListener("pagehide", function () {
      if (triggerObserver) triggerObserver.disconnect();
      Object.keys(faceStates).forEach(function (faceKey) {
        if (faceStates[faceKey].objectUrl) URL.revokeObjectURL(faceStates[faceKey].objectUrl);
      });
    });
  }

  document.querySelectorAll("[data-pos-design-maker-bridge]").forEach(initialize);
}());
